"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const getGradedEvent_1 = require("../helpers/getEvent/getGradedEvent");
const getInteractionKey_1 = require("../helpers/getInteraction/getInteractionKey");
const gradeInteraction_1 = require("../helpers/getInteraction/gradeInteraction");
const getState_1 = require("../helpers/getState");
const getStateInteraction_1 = require("../helpers/getStateInteraction");
const entity_1 = require("../type/entity");
function getGradeInteractionParam(command, user, content, grade, currentSubmission) {
    const { timeStamp, creatorId: teacherId, isAnonymous = false, actorType } = command;
    const { cardQuestionId, score } = grade;
    const { userId: studentId, companyId } = user;
    const { _id: rootContentId } = content;
    return {
        cardQuestionId,
        actorType,
        companyId,
        score,
        rootContentId,
        studentId,
        submissionId: currentSubmission._id,
        teacherId,
        timeStamp,
        isAnonymous
    };
}
function applyTeacherGradeCommand(command, user, content, states, stateInteractions) {
    const { creatorId: teacherId, grades, timeStamp, actorType } = command;
    const { userId } = user;
    const events = [];
    const updatedModel = immer_1.produce({
        stateInteractions,
        states
    }, InputModel => {
        const { stateInteractions: draftStateInteractions, states: draftStates } = InputModel;
        grades.forEach(grade => {
            const { cardQuestionId, score } = grade;
            const cardQuestionState = getState_1.getStateByContentIdUserId(draftStates, cardQuestionId, userId);
            if (!cardQuestionState) {
                throw new Error('no cardQuestion state with this questionId and userId');
            }
            const currentSubmission = cardQuestionState.submissions[0];
            // getting and upserting gradeInteractions
            const interactionKeyForLearner = getInteractionKey_1.getInteractionKeyForLearner(cardQuestionId, entity_1.InteractionType.Grade, currentSubmission._id, teacherId);
            let gradeInteraction = getStateInteraction_1.getStateInteractionByInteractionKeyForLearner(draftStateInteractions, interactionKeyForLearner);
            if (!gradeInteraction) {
                const gradeInteractionParam = getGradeInteractionParam(command, user, content, grade, currentSubmission);
                gradeInteraction = gradeInteraction_1.getGradeInteraction(gradeInteractionParam);
                draftStateInteractions.push(gradeInteraction);
            }
            else {
                gradeInteraction.actorType = actorType;
                gradeInteraction.score = score;
                gradeInteraction.deleted = false;
                gradeInteraction.updatedAt = timeStamp;
            }
            // updating submission
            currentSubmission.rawScore = cardQuestionState.rawScore = score;
            currentSubmission.gradedBy = teacherId;
            currentSubmission.gradedOn = timeStamp;
            // updating cardQuestion state
            cardQuestionState.updatedAt = timeStamp;
            const gradedEvent = getGradedEvent_1.getGradedEvent(command, user, content._id, entity_1.ContentType.CARD_QUESTION, grade, currentSubmission._id);
            events.push(gradedEvent);
        });
    });
    return Object.assign({ events, enrolments: [] }, updatedModel);
}
exports.applyTeacherGradeCommand = applyTeacherGradeCommand;
//# sourceMappingURL=applyTeacherGradeCommand.js.map